import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'LeadingZerosPipe'})
export class LeadingZerosPipe implements PipeTransform {
    transform(value: number, length: number): string {
        let result = '' + value;
        const zeroes = length - result.length;
        for (let i = 0; i < zeroes; i++) {
            result = '0' + result;
        }
        return result;
    }
}
